/* 🤖 this file was generated by svg-to-ts */
export const siriusSpeakerX: {
  name: 'speaker_x';
  data: string;
} = {
  name: 'speaker_x',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 3a.75.75 0 0 0-1.21-.592L7.241 7.5H3A1.5 1.5 0 0 0 1.5 9v6A1.5 1.5 0 0 0 3 16.5h4.242l6.547 5.092A.75.75 0 0 0 15 21V3ZM8.25 8.617l5.25-4.084v14.933l-5.25-4.083V8.617ZM6.75 9H3v6h3.75V9Z" fill="currentColor"/><path d="M23.03 10.28a.75.75 0 0 0-1.061-1.06l-1.72 1.719-1.719-1.72a.75.75 0 0 0-1.06 1.061L19.189 12l-1.72 1.719a.75.75 0 0 0 1.061 1.06l1.72-1.719 1.719 1.72a.75.75 0 0 0 1.06-1.061l-1.719-1.72 1.72-1.719Z" fill="currentColor"/></svg>`
};
